module.exports = {
    "dismiss": `\u{BB34}\u{C2DC}`
};


//# sourceMappingURL=ko-KR.main.js.map
